import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";

export const LogoutButton: React.FC = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
    sessionStorage.removeItem("token");
  };

  return (
    <Button onClick={handleLogout} fullWidth sx={{ color: "inherit" }}>
      <Typography variant="body2" fontWeight={"bold"}>
        Salir
      </Typography>
    </Button>
  );
};
